import React from 'react'
import magnifyingGlass from '../../../assets/images/magnifying-glass.png'

/**
 * SearchForm Component
 *
 * Reusable search form component extracted from Header
 * Handles search input and submission
 */
export const SearchForm = ({
  searchTerm,
  onSearchSubmit,
  onSearchInput,
  className = 'nav-search-form',
  placeholder = 'Search photos, categories, or events...'
}) => {
  return (
    <form action="" className={className} onSubmit={onSearchSubmit} id="nav-search-form">
      <input
        type="search"
        id="nav-search-bar"
        value={searchTerm}
        onChange={onSearchInput}
        placeholder={placeholder}
      />
      <button type="submit" id="nav-search-submit" aria-label="Search">
        <img src={magnifyingGlass} className="nav-search-mag" alt="" />
      </button>
    </form>
  )
}
